import styles from "./index.module.scss";

export const Processing = () => (
    <div className={styles["loading-container"]}>
        <div className={styles["dot"]} />
        <div className={styles["dot"]} />
        <div className={styles["dot"]} />
    </div>
);
